import * as React from "react";
import { filter } from "graphql-anywhere";
import { makeStyles } from "@mui/styles";
import { fragments as productionJobLineItemBreakdownTableFragments } from "../../../../../../../components/ProductionJobLineItemBreakdownTable/graph";
import { fragments as styleSubstitutionLineItemBreakdownFragments } from "../../../../../../../components/StyleSubstitutionLineItemBreakdown/graph";
import ProductionJobLineItemBreakdownTable from "../../../../../../../components/ProductionJobLineItemBreakdownTable";
import StyleSubstitutionLineItemBreakdown from "../../../../../../../components/StyleSubstitutionLineItemBreakdown";
import Typography from "@mui/material/Typography";

const pluralize = require("pluralize");

const useStyles = makeStyles(theme => ({
  name: {
    marginRight: theme.spacing(1)
  },
  tableContainer: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2)
  },
  textWrapper: {
    display: "flex",
    flexDirection: "row"
  }
}));

const ProductionJobLineItemBreakdown = ({ productionJobLineItemBreakdown }) => {
  const classes = useStyles();

  return (
    <div className={classes.tableContainer}>
      <div className={classes.textWrapper}>
        <Typography className={classes.name} variant="h6" color="textSecondary">
          {productionJobLineItemBreakdown.product.fullDisplayName}
        </Typography>
        <Typography variant="h6" color="textSecondary">
          {`(${pluralize(
            "piece",
            productionJobLineItemBreakdown.totalProductVariantQuantity,
            true
          )})`}
        </Typography>
      </div>
      {productionJobLineItemBreakdown.product.isStyleSubstitution ? (
        <StyleSubstitutionLineItemBreakdown
          lineItems={filter(
            styleSubstitutionLineItemBreakdownFragments.lineItems,
            productionJobLineItemBreakdown.lineItems
          )}
        />
      ) : (
        <ProductionJobLineItemBreakdownTable
          lineItems={filter(
            productionJobLineItemBreakdownTableFragments.lineItems,
            productionJobLineItemBreakdown.lineItems
          )}
        />
      )}
    </div>
  );
};

export default ProductionJobLineItemBreakdown;
